import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { DocumentTypeEntity } from '../../distribution/models';
import { DataGroupPresentation, DataGroupEntity } from '../models';
import { JsonHttpService } from '../../shared/http/json-http.service';

export class PartnerRemovalResult {
    PartnerId: number;
    RemovalAllowed: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class DataGroupService {

    constructor(private httpService: JsonHttpService) { }

    /**
     * Get UserGroups for the given parameters
     * @param includeRoles True if the UserGroup objects should contain Role objects
     */
    getDataGroups(includePartners: boolean, includeDistributionObjects: boolean): Promise<DataGroupPresentation[]> {
        const options = {
            params: new HttpParams()
                .set('includePartners', `${!!includePartners}`)
                .set('includeDistributionObjects', `${!!includeDistributionObjects}`)
        };
        return this.httpService.get('/api/users/datagroups/get-groups', options).toPromise();
    }

    getDataGroupsForOverview(): Promise<DataGroupPresentation[]> {

        return this.httpService.get('/api/users/datagroups/get-groups-overview').toPromise();
    }

    getDataGroup(datagroupId: number, includePartners: boolean, includeDistributionObjects: boolean): Promise<DataGroupPresentation> {
        const options = {
            params: new HttpParams()
                .set('includePartners', `${!!includePartners}`)
                .set('includeDistributionObjects', `${!!includeDistributionObjects}`)
                .set('datagroupId', `${datagroupId}`)
        };
        return this.httpService.get('/api/users/datagroups/get-group', options).toPromise();
    }

    /**
     * Get UserGroups for the given parameters
     * @param includeRoles True if the UserGroup objects should contain Role objects
     */
    getDataGroupsForCurrentUser(includePartners: boolean, includeDistributionObjects: boolean): Promise<DataGroupPresentation[]> {
        const options = {
            params: new HttpParams()
                .set('includePartners', `${!!includePartners}`)
                .set('includeDistributionObjects', `${!!includeDistributionObjects}`)
        };
        return this.httpService.get('/api/users/datagroups/get-groups-for-current-user', options).toPromise();
    }

    addPartnerToDataGroups(partnerId: number, datagroupIds: number[]): Promise<void> {
        const options = { params: new HttpParams().set('partnerId', `${partnerId}`) };
        datagroupIds.forEach(datagroupId => options.params = options.params.append('datagroupId', `${datagroupId}`));
        return this.httpService.post('/api/users/datagroups/add-partner-to-data-groups', null, options).toPromise();
    }

    saveDataGroup(usergroup: DataGroupPresentation): Promise<DataGroupPresentation> {
        return this.httpService.post('/api/users/datagroups/save-group', usergroup).toPromise();
    }

    validatePartnerRemoval(partnerIds: number[], dataGroupId: number): Promise<PartnerRemovalResult[]> {
        const options = { params: new HttpParams().set('dataGroupId', `${dataGroupId}`) };
        return this.httpService.post('/api/users/datagroups/validate-partner-removal', partnerIds, options).toPromise();
    }

    deleteDataGroup(userGroupId: number): Promise<void> {
        const options = { params: new HttpParams().set('dataGroupId', `${userGroupId}`) };
        return this.httpService.post('/api/users/datagroups/delete-group', null, options).toPromise();
    }

    /**
     * Get all the distribution-objects. This method will ignore data-access restriction, but requires 'DataGroup_Action_Create' or 'DataGroup_Action_Edit' permissions.
     */
    getDistributionObjects(): Promise<DocumentTypeEntity[]> {
        return this.httpService.get('/api/users/datagroups/get-distributionobjects').toPromise();
    }
}
